import $ from 'jquery';

export function disableProductsClick() {
  $('a').css('pointer-events', 'none');
  const el = document.getElementById('product-menu');
  if (el) el.style.pointerEvents = 'none';
}
export function enableProductsClick() {
  $('a').css('pointer-events', 'auto');
  const el = document.getElementById('product-menu');
  if (el) el.style.pointerEvents = 'auto';
}



// WEBPACK FOOTER //
// ./src/helpers/click.js